import React from 'react'
import { Route } from 'react-router-dom'
import RoutesWrapper from '../RoutesWrapper'

const Stage6 = React.lazy(
  () => import('../../pages/stages/stage6/Stage6Main'),
)
const Stage6Story = React.lazy(
  () => import('../../pages/stages/stage6/Stage6Story'),
)
const Stage6Ending = React.lazy(
  () => import('../../pages/stages/stage6/Stage6Ending'),
)

const loc = `stage6`

export const Stage6Routes = (
  <>
    <Route
      path="/stage6"
      element={
        <RoutesWrapper loc={loc}>
          <Stage6 />
        </RoutesWrapper>
      }
    />
    <Route
      path="/stage6/story"
      element={
        <RoutesWrapper loc={loc}>
          <Stage6Story />
        </RoutesWrapper>
      }
    />
    <Route
      path="/stage6/ending"
      element={
        <RoutesWrapper loc={loc}>
          <Stage6Ending />
        </RoutesWrapper>
      }
    />
  </>
)
